exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.kcal-input-mode-radio[data-v-d0a2f070] {\n  margin-left: 80px;\n}\n", ""]);

// exports
